import { defineStore } from 'pinia'
import type { OnboardingStateMap, OnboardingStep } from '~/onboarding/types'

interface OnboardingStoreState {
  stateMap: OnboardingStateMap
  hasHydrated: boolean
  activeTourId: string | null
  activeTourSteps: OnboardingStep[] | null
  pendingTeleportIndex: number | null
}

export const useOnboardingStore = defineStore('onboarding', {
  state: (): OnboardingStoreState => ({
    stateMap: {},
    hasHydrated: false,
    activeTourId: null,
    activeTourSteps: null,
    pendingTeleportIndex: null,
  }),

  getters: {
    isTourActive: (state): boolean => state.activeTourId !== null,
  },

  actions: {
    setStateMap(nextState: OnboardingStateMap): void {
      this.stateMap = nextState
    },

    setHasHydrated(value: boolean): void {
      this.hasHydrated = value
    },

    setActiveTourId(tourId: string | null): void {
      this.activeTourId = tourId
    },

    setActiveTourSteps(steps: OnboardingStep[] | null): void {
      this.activeTourSteps = steps
    },

    setPendingTeleportIndex(index: number | null): void {
      this.pendingTeleportIndex = index
    },

    resetRuntimeState(): void {
      this.activeTourId = null
      this.activeTourSteps = null
      this.pendingTeleportIndex = null
    },
  },
})
